export const MSEnum = {
    /**
     * Định dạng dữ liệu hiển thị
     */
    FormatType: {
        /// <summary>
        /// Loại mà không xử lý gì cả
        /// </summary>
        /// <remarks></remarks>
        None: 0,
        ///Định dạng cho tiền hạch toán
        ///Đơn giá
        UnitPrice: 1,
        ///Thành tiền quy đổi
        Amount: 2,
        ///-----------------------------------
        ///Hệ số, Tỷ lệ
        Rate: 3,
        ///Tỷ giá
        ExchangeRate: 4,
        ///Định dạng cho tiền ngoai te
        ///Đơn giá
        UnitPriceOC: 5,
        ///Thành tiền nguyên tệ
        AmountOC: 6,
        ///Hệ số, tỷ lệ phân bổ
        Allocation: 7,
        ///-----------------------------------
        ///Số lượng
        QuantityConvert: 8,
        ///Số lượng
        Quantity: 11,
        //Kiểu chữ
        Text: 12,
        //Kiểu tích chọn
        Checkbox: 13,
        //Kiểu ngày tháng
        Date: 14,
        //Kiểu danh sách
        List: 15,
        //Kiểu thời gian
        Time: 16,
        // Join mảng theo dấu ;
        Join: 17,
        //Group Item
        GroupItem: 18,
        //Kiểu ngày/tháng/năm có giờ
        DateTime: 19,
        //Kiểu số không có định dạng sau dấu phẩy
        Number: 20,
        //Kiểu text nhưng trên grid khi click vào sẽ drilldown
        Drilldown: 21,
        //Format trạng thái
        Status: 22,
        //Format giới tính
        Gender: 23,
        //pvduy 12/04/2021 Format file size
        FileSize: 24,
        //ntnghia 04/05/2021 Format tiến độ %
        Progress: 25,
        //Kiểu chữ trong textarea
        TextArea: 26,
        //Định dạng dữ liệu html
        Html: 99,
        //Kiểu enum
        Enum: 100
    },
    OptionFormat: {
        None: -1, //mặc định
        ZeroToMinus: 0, //nếu giá trị là số không thì trả về '-'
        ZeroToZero: 1, //nếu giá trị là số không thì trả về 0
        ZeroToEmpty: 2, //nếu giá trị là số không thì trả về trống
        EmptyToMinus: 3, //nếu giá trị là trống thì trả về '-'
        EmptyToZero: 4, //nếu giá trị là trống thì trả về 0
        EmptyToEmpty: 5, //nếu giá trị là trống thì trả về trống

    },
    /**
     * Trạng thái sắp xếp
     */
    SortStatus: {
        /**
         * Không sort
         */
        none: 0,
        /**
         * Giảm dần
         */
        desc: 1,
        /**
         * Tăng dần
         */
        asc: 2
    },
    /**
     * Trạng thái của form
     */
    FormState: {
        /**
         * Mode View
         */
        View: 0,
        /**
         * Thêm
         */
        Add: 1,
        /**
         * Sửa
         */
        Edit: 2,
        /**
         * Nhân bản
         */
        Duplicate: 4,
        /**
         * Thêm nhanh
         */
        QuickAdd: 5,
        // THêm sau khi lưu vào db- dành cho thêm nội dung bảo dưỡng khi đang thêm tài sản
        LastAdd: 6
    },
    /**
     * Mode save truyền lên server để điều khiển
     */
    SaveMode: {
        Save: 0,
        SaveNew: 1,
        SaveView: 2, // pvduy 04/03/2021 cất tại trường hợp mode view
        SaveAndConfig: 3 // nnlam 05/07/2021 : cất và config cái gì đó ( mở 1 popup khác lên chẳng hạn)
    },
    /**
     * Các loại kết quả validate trả về lỗi
     */
    ValidateResultType: {
        /**
         * Lỗi
         * Hiển thị thông báo và dừng lại
         */
        Error: 0,
        /**
         * Thông tin
         * Hiển thị thông báo và vẫn tiếp tục xử lý
         */
        Info: 1,
        /**
         * Cảnh báo - chỉ thông báo
         * Hiển thị thông báo và vẫn tiếp tục xử lý
         */
        Alert: 2,
        /**
         * Cảnh báo - cần xác nhận
         * Hiển thị confirm có tiếp tục xử lý không
         */
        Warning: 9
    },

    Inactive: {
        Inactive: 1, // Ngừng theo dõi
        Active: 0, // Đang theo dõi
    },
    /**
     * Các loại file
     */
    StorageFileType: {
        /**
         * File tạm
         */
        Temp: 0,
        /**
         * File đính kèm
         */
        Attachment: 1,
    },
    /**
     * Loại cột - xác định editor
     */
    ColumnType: {
        Text: 0,
        Combobox: 1,
        Number: 2,
        Checkbox: 3,
        Datepicker: 5,
        Dropdown: 6,
        Template: 7,
        TextArea: 8,
        Enum: 9
    },
    /**
     * Trạng thái của model
     */
    ModelState: {
        None: 0,
        Insert: 1,
        Update: 2,
        Delete: 3
    },
    /**
     * Giới tính
     */
    Gender: {
        Female: 0,
        Male: 1,
        Other: 3
    },
    /**
     * Filter header của grid
     */
    FilterHeader: {
        Contains: "contains",
        Notcontains: "notContains",
        StartsWith: "startsWith",
        EndsWith: "endsWith",
        Null: "is null",
        NotNull: "is not null",
        Equals: "=",
        NotEquals: "!=",
        GreaterThan: ">",
        GreaterThanEquals: ">=",
        LessThan: "<",
        LessThanEquals: "<=",
        Between: "[]"
    },
    /**
     * Các hàm ở footer cần xử lý
     */
    SummaryType: {
        /// <summary>
        /// Sum dữ liệu đang hiển thị
        /// </summary>
        Sum: "sum",
        /// <summary>
        /// Sum tất cả dữ liệu trong store
        /// </summary>
        SumAll: "sumAll",
        /// <summary>
        /// Trung bình
        /// </summary>
        Avg: "avg",
        /// <summary>
        /// Nhỏ nhất
        /// </summary>
        Min: "min",
        /// <summary>
        /// Lớn nhất
        /// </summary>
        Max: "max",
        /// <summary>
        /// Text custom
        /// </summary>
        Text: "text"
    },
    /*
     * Các kỳ liên quan đến khoảng thời gian phục vụ cho control DateRange
     * CreatedBy DNThang - 02.07.2019
     */
    Period: {
        ThisDay: 20,
        ThisWeek: 30,
        FirstWeekToPresent: 31,
        ThisMonth: 45,
        FirstMonthToPresent: 46,
        ThisQuarter: 60,
        FirstQuarterToPresent: 61,
        ThisYear: 500,
        FirstYearToPresent: 501,
        SixFirstMonth: 75,
        SixLastMonth: 70,
        // Các tháng trong năm
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,

        //Qúy
        FiscalI: 100, //Qúy 1
        FiscalII: 200,
        FiscalIII: 300,
        FiscalIV: 400,

        Yesterday: 21,
        LastWeek: 35,
        LastMonth: 50,
        LastQuarter: 65,
        LastYear: 80,

        Tomorrow: 25,
        NextWeek: 40,
        NextMonth: 55,
        NextQuarter: 66,
        NextYear: 90,
        // FourLastWeek: 41,
        // ThreeLastYear: 85,
        Custom: 0
    },

    /**
     * Các loại kỳ báo cáo
     */
    PeriodType: {
        Month: 1,
        Quarter: 2,
        Year: 3
    },
    /*
     * Loại màn hình
     */
    FormType: {
        //Danh sách
        List: 1,
        //Tìm nhanh
        QuickSearch: 2,
    },
    /**
     * Enum cấu hình style của ô check box multi-grid
     */
    ShortKeyToolTip: {
        Add: 'F9',
        Close: 'ESC', //Đóng
        Save: 'Ctrl + S',  //Cất
        SaveAndAdd: 'Ctrl + Shift + S',  //Cất và thêm
        Help: 'F1',  //Giúp
        Print: 'Ctrl + P',  //IN
        Maximum: 'Ctrl + Space',  //phóng to thu nhỏ form
        QuickSelect: 'F3', //chọn nhanh
    },
    EmployeeType: {
        Probation: 0,
        Office: 1,
        Manage: 2,
    },
    /**
     * Các loại action của nhật ký truy cập
     */
    AuditingLogAction: {
        // không ghi nhật ký
        None: 0,
        /*
         * Đăng nhập
         */
        Login: 1,
        /*
         * Đăng xuất
         */
        Logout: 2,
        /**
         * Hủy
         */
        Cancel: 8,
        /*
         * Thêm dữ liệu
         */
        Insert: 10,
        /*
         * Sửa dữ liệu
         */
        Edit: 11,
        /*
         * Xóa dữ liệu
         */
        Delete: 12,
        /*
         * Thêm dữ liệu hàng loạt
         */
        InsertMulti: 13,
        /*
         * Xóa dữ liệu hàng loạt
         */
        DeleteMulti: 14,
        /*
         * Nhập khẩu
         */
        Import: 16,
    },
    ServiceResponseCode: {
        ErrorVersion : 54 // version của bản ghi bị cũ
    },

    /**
     * Loại cơ cấu tổ chức
     * pvduy 02/02/2021: sửa lại enum do trước fix nhầm
     */
    OrganizationUnitType: {
        /**
         * Tổng công ty
         */
        Corporations: 1,
        /**
         * Tập đoàn
         */
        Group: 2,
        /**
         * Công ty con
         */
        Subsidiaries: 3,
        /**
         * Chi nhánh
         */
        Branch: 4,
        /**
         * Văn phòng đại điện
         */
        Representative: 5,
        /**
         * Văn phòng
         */
        Office: 6,
        /**
         * Trung tâm
         */
        Center: 7,
        /**
         * Phòng ban
         */
        Department: 8,
        /**
         * NHóm/tổ/đội
         */
        Team: 9,
        /**
         * Phân xưởng
         */
        Factory: 10
    },
    /**
     * Loại nghiệp vụ xóa
     */
    DeleteType: {
        // xóa 1 bản ghi
        Single: 1,
        // xóa hàng loạt
        Multi: 2
    },

    ReportType:    {
        ProcessStatus : 1, // Tổng hợp kiến nghị theo đơn vị trả lời kiến nghị
        ProcessField : 2, // Tổng hợp kiến nghị theo lĩnh vực
        ProcessOrganizationOwner : 3, // Tổng hợp kiến nghị theo đơn vị kiến nghị
        ProcessOrganizationReply : 4, // Tổng hợp kiến nghị theo đơn vị trả lời kiến nghị
    },

    NotifyType: {
        Approve : 1, // Tiếp nhận
        Assign : 2, // Đề nghị,
        Reject : 3, // Từ chối
        ReAssign : 4, // Phân công lại,
        Relate : 5, // Liên quan
        Comment : 6, // Bình luận
        Reply : 7 // Trả lời bình luận
    },

    RequestTerm : {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
        Quarter1: 13,
        Quarter2: 14,
        Quarter3: 15,
        Quarter4: 16,
        CurrentYear: 17,
        ChooseTime: 18,
    }
};